﻿import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';

export default function LogoutConfirmDialog({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '20px', overflow: 'hidden' } }}
    >
      <DialogContent sx={{ pt: 4, px: 4, pb: 1 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2.5,
          }}
        >
          <LogoutIcon sx={{ color: 'error.main', fontSize: '1.375rem' }} />
        </Box>
        <Typography sx={{ fontWeight: 600, fontSize: '1.1875rem', mb: 1 }}>
          Log out of your account?
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.90625rem',
            lineHeight: 1.6,
          }}
        >
          You'll need to sign in again to access your dashboard and saved data.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 4, pt: 3, gap: 1.5 }}>
        <Button
          onClick={onClose}
          sx={{
            fontFamily: 'inherit',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: '#64748b',
            backgroundColor: '#f1f5f9',
            borderRadius: '12px',
            px: 3.5,
            py: 1.4,
            textTransform: 'none',
            border: '1px solid #e2e8f0',
            '&:hover': { backgroundColor: '#e2e8f0' },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          sx={{
            fontFamily: 'inherit',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: '#fff',
            backgroundColor: '#dc2626',
            borderRadius: '12px',
            px: 3.5,
            py: 1.4,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(220,38,38,0.3)',
            '&:hover': { backgroundColor: '#b91c1c' },
          }}
        >
          Log out
        </Button>
      </DialogActions>
    </Dialog>
  );
}
